import {
  Grid,
  Stack,
  Text,
} from '@mantine/core'
import { IconBan } from '@tabler/icons-react'

import { getPowerStatus } from '@common/utils/helperFunctions'
import {
  formatTableDate,
  toSortableTime,
} from '@components/main/DeviceManagement/DeviceInformationManager/deviceInformationTable.helpers'
import { BattIcon } from '@components/ui/BattIcon'
import { ReadOnlyField } from '@components/ui/form/ReadOnlyField'
import { SignalIcon } from '@components/ui/SignalIcon'
import { type TestDevice } from '@data/device/model/device'

export interface TestDeviceStatusTabProps {
  device: TestDevice
}

// Not Device Management's DeviceStatusTab, which reads `deviceSettings.deviceState` and the
// Online/Offline status `mapDevice` derives by comparing `last_ping` against the upload
// frequency. A test device has no settings, so neither exists. Connection State here is the
// raw `connection_state` the API reports, and is not interchangeable with that derived status.
export const TestDeviceStatusTab = ({ device }: TestDeviceStatusTabProps) => (
  <Stack gap='lg'>
    <Grid>
      <Grid.Col span={{ base: 12, md: 6 }}>
        <Stack gap={4}>
          <Text fw={600}>
            Battery
          </Text>

          <BattIcon device={device} />
        </Stack>
      </Grid.Col>

      <Grid.Col span={{ base: 12, md: 6 }}>
        {device.batteryStatus ? (
          <ReadOnlyField
            label='Power'
            value={getPowerStatus(device)}
          />
        ) : (
          <Stack gap={4}>
            <Text fw={600}>
              Power
            </Text>

            <IconBan size={18} />
          </Stack>
        )}
      </Grid.Col>
    </Grid>

    <Grid>
      <Grid.Col span={{ base: 12, md: 6 }}>
        <Stack gap={4}>
          <Text fw={600}>
            Signal
          </Text>

          <SignalIcon signalLevel={device.signal} />
        </Stack>
      </Grid.Col>

      <Grid.Col span={{ base: 12, md: 6 }}>
        <ReadOnlyField
          label='State'
          value={device.state}
        />
      </Grid.Col>
    </Grid>

    <Grid>
      <Grid.Col span={{ base: 12, md: 6 }}>
        <ReadOnlyField
          label='Connection State'
          value={device.connectionStatus}
        />
      </Grid.Col>

      <Grid.Col span={{ base: 12, md: 6 }}>
        <ReadOnlyField
          label='Last Check In'
          value={formatTableDate(toSortableTime(device.lastOnline), true)}
        />
      </Grid.Col>
    </Grid>
  </Stack>
)
